<template>
  <div>
    <v-row>
      <v-col cols="12" :md="modalView ? 12 : 8" :offset-md="modalView ? 0 : 2" :lg="modalView ? 12 : 8" :offset-lg="modalView ? 0 : unset">
        <form @submit.prevent="save">
          <!-- {{ users.map(u => ({ a: u.complete_name, b: u.moniker })) }} -->
          <v-select
            :disabled="article.start_id || article.stop_id"
            :items="users"
            item-text="moniker"
            item-value="id"
            ref="user"
            v-model="form.user"
            label="Uporabnik"
          ></v-select>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.user.required || !$v.form.user.unique)"
          >
            <FormErrorsLine v-if="!$v.form.user.required" text="Polje je obvezno" />
            <FormErrorsLine v-if="!$v.form.user.unique" text="Uporabnik z istim imenom že obstaja" />
          </FormErrors>

          <DateTimeSelector
            labelDate="Od"
            :date="form.startDate"
            :time="form.startTime"
            @change="updateStartDateTime"
          />
          <FormErrors
            v-if="$v.form.$error && (!$v.form.startTime.unique || !$v.form.startTime.cover || !$v.form.startTime.required)"
          >
            <FormErrorsLine v-if="!$v.form.startTime.required" text="Polje je obvezno" />
            <FormErrorsLine v-if="!$v.form.startTime.unique" text="Čas prihoda je pred časom odhoda" />
            <FormErrorsLine v-if="!$v.form.startTime.cover" :text="`Čas prihoda se prekriva s časom ${lastSessionEndFormated} odhoda prejšnje seje`" />
          </FormErrors>

          <!-- {{ form.startDate }} {{ form.startTime }}
          A{{ lastSessionEnd }} B{{ nextSessionStart }}
          {{ dateLastNextSessions[form.startDate] }} -->

          <DateTimeSelector
            labelDate="Do"
            :date="form.stopDate"
            :time="form.stopTime"
            @change="updateEndDateTime"
          />
          <FormErrors
            v-if="$v.form.$error && (!$v.form.stopTime.unique || !$v.form.stopTime.cover)"
          >
            <FormErrorsLine v-if="!$v.form.stopTime.unique" text="Čas odhoda je pred časom prihoda" />
            <FormErrorsLine v-if="!$v.form.stopTime.cover" :text="`Čas odhoda se prekriva s časom ${nextSessionStartFormated} prihoda naslednje seje`" />
          </FormErrors>

          <!-- <v-row>
            <v-col cols="6">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.activated_pause"
                label="Je koristil odmor"
              ></v-checkbox>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="form.startExchange"
                @blur="parseFormStartExchange"
                label="Menjalnina prihod"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="form.stopExchange"
                @blur="parseFormStopExchange"
                label="Menjalnina odhod"
              ></v-text-field>
            </v-col>
          </v-row>

          <br>
          <v-btn v-if="!skrij" type="submit" class="float-right" :disabled="disabled">Shrani</v-btn>
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="$emit('cancel')">Prekliči</v-btn>
          <!-- <div style="display: none;">
            {{spremenjenoIme}}
            {{spremenjenoInformacije}}
            {{spremenjenoCena}}
            {{spremenjenoGroup}}
            {{spremenjenoCategory}}
            {{spremenjenoEnotaNakupa}}
            {{spremenjenoEnotaProdaje}}
            {{spremenjenoVisible}}
            {{spremenjenoAskPrice}}
            {{spremenjenoAskQnt}}
            {{spremenjenoNameChange}}
          </div> -->
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import DateTimeSelector from '@/components/DateTimeSelector'
import { parsePrice } from '@/utils/price'
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    DateTimeSelector,
    FormErrors,
    FormErrorsLine
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    modalView: {
      default: false,
      type: Boolean
    },
    users: {
      required: true,
      type: Array
    },
    skrij: {
      required: false,
      default: false,
      type: Boolean
    },
    dateLastNextSessions: {
      type: Object
    }
  },
  data () {
    return {
      localStaraForm: null,
      localCategories: [],
      localGroups: [],
      showAddCategoryModal: false,
      showAddGroupModal: false,
      disabled: false,
      yesterday: false,
      tomorrow: false,
      lastSessionData: null,
      nextSessionData: null,
      lastSessionEnd: null,
      nextSessionStart: null,
      emptyForm: {
        user: '',
        startDate: '',
        startTime: '',
        stopDate: '',
        stopTime: '',
        activated_pause: null,
        startExchange: '0,00',
        start_id: null,
        stop_id: null,
        stopExchange: '0,00'
      },
      form: {},
      dataFetched: false,
      razlog: null
    }
  },
  validations: {
    form: {
      user: {
        required,
        unique (val) {
          if (!val.length) return true
          const matchingArticle = this.articles.filter(article => siMatch({ str1: article.name, str2: val }))
          return (Array.isArray(matchingArticle) && matchingArticle.length === 0) || (!this.isNewArticle && matchingArticle[0].id === this.article.id)
        }
      },
      startTime: {
        required,
        unique (val) {
          console.log('uniq: ', val)
          if (!val) return true
          if (!val.length) return true
          if (!this.form.stopTime) return true
          // if (!this.tomorrow) return true
          const dateStart = `${this.form.startDate}T${val}:00`
          const dateStop = `${this.form.stopDate}T${this.form.stopTime}:00`
          return (moment(dateStart).isBefore(moment(dateStop)))
          // return false
        },
        cover (val) {
          console.log('searching a')
          if (!val) return true
          console.log('searching')
          this.findSessions()
          if (!this.lastSessionEnd) return true
          const dateStart = `${this.form.startDate}T${this.form.startTime}:00`
          const dateStop = `${this.form.stopDate}T${val}:00`
          // console.log((moment(dateStart).isAfter(moment(this.lastSessionEnd))))
          return (moment(dateStart).isAfter(moment(this.lastSessionEnd)))
          // return false
        }
      },
      stopTime: {
        unique (val) {
          if (!val) return true
          if (!val.length) return true
          if (!this.form.startTime) return true
          // if (!this.tomorrow) return true
          const dateStop = `${this.form.stopDate}T${val}:00`
          const dateStart = `${this.form.startDate}T${this.form.startTime}:00`
          return (moment(dateStart).isBefore(moment(dateStop)))
          // return false
        },
        cover (val) {
          if (!val) return true
          if (!val.length) return true
          this.findSessions()
          if (!this.nextSessionStart) return true
          const dateStart = `${this.form.startDate}T${this.form.startTime}:00`
          const dateStop = `${this.form.stopDate}T${val}:00`
          // console.log(moment(dateStop).isBefore(moment(this.nextSessionStart)), this.nextSessionStart)
          return (moment(dateStop).isBefore(moment(this.nextSessionStart)))
          // return false
        }
      }
    }
  },
  computed: {
    lastSessionEndFormated () {
      return this.lastSessionEnd ? moment(this.lastSessionEnd).format('DD.MM.YYYY HH:mm') : ''
    },
    nextSessionStartFormated () {
      return this.nextSessionStart ? moment(this.nextSessionStart).format('DD.MM.YYYY HH:mm') : ''
    },
    measurementUnits () {
      const units = objectToArray(this.$store.state.measurementUnits.items)
      const sortedArr = units.reduce((acc, element) => {
        if (element.name === 'Por' || element.name === 'L' || element.name === 'Kos' || element.name === 'Kg') {
          return [element, ...acc]
        }
        return [...acc, element]
      }, [])
      return [ { id: null, name: 'Brez enote' }, ...sortedArr ]
    },
    isNewArticle () {
      return this.article ? Object.keys(this.article).length === 0 || !this.article.id : true
    },
    /* articleName () {
      return this.form.name
    },
    spremenjenoIme () {
      return this.localStaraForm ? this.form.name !== this.localStaraForm.name : false
    },
    spremenjenoInformacije () {
      return this.localStaraForm ? this.form.description !== this.localStaraForm.description : false
    },
    spremenjenoCena () {
      return this.localStaraForm ? this.form.price !== this.localStaraForm.price : false
    },
    spremenjenoGroup () {
      return this.localStaraForm ? this.form.group !== this.localStaraForm.group : false
    },
    spremenjenoCategory () {
      return this.localStaraForm ? this.form.category !== this.localStaraForm.category : false
    },
    spremenjenoEnotaNakupa () {
      return this.localStaraForm ? this.form.purchase_measurement_unit !== this.localStaraForm.purchase_measurement_unit : false
    },
    spremenjenoEnotaProdaje () {
      return this.localStaraForm ? this.form.sell_measurement_unit !== this.localStaraForm.sell_measurement_unit : false
    },
    spremenjenoVisible () {
      return this.localStaraForm ? this.form.is_visible !== this.localStaraForm.is_visible : false
    },
    spremenjenoAskPrice () {
      return this.localStaraForm ? this.form.ask_for_price !== this.localStaraForm.ask_for_price : false
    },
    spremenjenoAskQnt () {
      return this.localStaraForm ? this.form.ask_for_quantity !== this.localStaraForm.ask_for_quantity : false
    },
    spremenjenoNameChange () {
      return this.localStaraForm ? this.form.name_change_allowed !== this.localStaraForm.name_change_allowed : false
    } */
  },
  methods: {
    ...mapActions('measurementUnits', { 'loadMeasurementUnits': 'loadItems' }),
    ...mapActions('categories', { createNewCategory: 'saveItem' }),
    ...mapActions('groups', { createNewGroup: 'saveItem' }),
    findSessions () {
      // 2023-11-01
      // console.log(this.form.startDate, this.dateLastNextSessions[this.form.startDate])
      // najdi najblizjo za nazaj
      if (!this.dateLastNextSessions[this.form.startDate]) {
        let counter = 10
        for (var i = 1; i <= counter; i++) {
          let otherDay = moment(new Date(this.form.startDate)).subtract(i, 'days').format('YYYY-MM-DD') // .format('DD.MM.YYYY')

          if (this.dateLastNextSessions[otherDay]) {
            // console.log(this.dateLastNextSessions[otherDay], this.dateLastNextSessions[otherDay].currentSessionData.stopTime)
            this.lastSessionEnd = this.dateLastNextSessions[otherDay].currentSessionData.stopTime
            if (this.dateLastNextSessions[otherDay].nextSessionData) {
              this.nextSessionStart = this.dateLastNextSessions[otherDay].nextSessionData.startTime
            }
            break
          }
          console.log('i: ', i, otherDay)
        }
      } else {
        // trenutni datum ze obstaja zapisan
        console.log(this.dateLastNextSessions[this.form.startDate])
        const counter = 10
        for (var i = 1; i <= counter; i++) {
          let otherDay = moment(new Date(this.form.startDate)).subtract(i, 'days').format('YYYY-MM-DD') // .format('DD.MM.YYYY')

          if (this.dateLastNextSessions[otherDay]) {
            this.lastSessionEnd = this.dateLastNextSessions[otherDay].currentSessionData.stopTime
            /* if (this.dateLastNextSessions[otherDay].nextSessionData) {
              this.nextSessionStart = this.dateLastNextSessions[otherDay].nextSessionData.startTime
            } */
            break
          }
        }
        for (var i = 1; i <= counter; i++) {
          let otherDay = moment(new Date(this.form.startDate)).add(i, 'days').format('YYYY-MM-DD') // .format('DD.MM.YYYY')

          if (this.dateLastNextSessions[otherDay]) {
            this.nextSessionStart = this.dateLastNextSessions[otherDay].currentSessionData.startTime
            break
          }
        }
      }
    },
    updateStartDateTime ({ date, time }) {
      this.form.startDate = date
      this.form.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.form.stopDate = date
      this.form.stopTime = time
    },
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        // console.log(this.form)
        /* if (!this.dateLastNextSessions[this.form.startDate] && this.nextSessionStart && !this.form.stopDate && !this.form.stopTime){
          const finishtime = moment(this.nextSessionStart).subtract(1, 'minute').format('YYYY-MM-DDTHH:mm:ss').split('T')
          // console.log(finishtime)
          this.form.stopDate = finishtime[0]
          this.form.stopTime = finishtime[1]
        } */
        // console.log(this.form, this.nextSessionStart)
        this.$emit('submit', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$emit('save', { data: this.form, repeat: true })
    },
    saveAndRepeatClear () {
      setTimeout(() => {
        this.form.user = ''
        this.form.startExchange = 0
        this.form.stopExchange = 0
        this.$refs.user.focus()
      }, 50)
    },
    clearForm () {
      this.form = { ...this.emptyForm }
    },
    cancel () {
      this.$emit('cancel')
    },
    toggleAutoSortOrder () {
      if (this.sortOrderCheckbox) {
        this.form.sort_order = null
      }
    },
    parseFormStartExchange () {
      this.form.startExchange = parsePrice(this.form.startExchange)
    },
    parseFormStopExchange () {
      this.form.stopExchange = parsePrice(this.form.stopExchange)
    },
  },
  mounted () {
    if (this.article) {
      this.$nextTick(() => {
        this.dataFetched = true
      })
    }
  },
  created () {
    this.localCategories = this.categories
    this.localGroups = this.groups
    this.form = { ...this.emptyForm }
    if (this.article) {
      this.form = { ...this.form, ...this.article, yesterday: null, tomorrow: null }
      if (this.article.user) {
        this.form.user = this.users.find(us => us.moniker === this.article.user || us.complete_name === this.article.user).id
      }
      if (this.article.startDate && this.article.start_id) {
        const startDateSplit = this.form.startDate.split('.')
        const startTimeSplit = this.form.startTime.split(':')
        this.form.startDate = `${startDateSplit[2]}-${startDateSplit[1]}-${startDateSplit[0]}`
        this.form.startTime = `${startTimeSplit[0]}:${startTimeSplit[1]}`
      } else {
        this.form.startDate = null
        this.form.startTime = null
      }

      if (this.article.stopTime && this.article.stop_id) {
        const stopDateSplit = this.form.stopDate.split('.')
        const stopTimeSplit = this.form.stopTime.split(':')
        this.form.stopDate = `${stopDateSplit[2]}-${stopDateSplit[1]}-${stopDateSplit[0]}`
        this.form.stopTime = `${stopTimeSplit[0]}:${stopTimeSplit[1]}`
      } else {
        this.form.stopDate = null
        this.form.stopTime = null
      }
      // if ()
      this.start_id = this.article.start_id
      this.stop_id = this.article.stop_id
      this.form.startExchange = parsePrice(this.form.startExchange)
      this.form.stopExchange = parsePrice(this.form.stopExchange)
      this.yesterday = this.article.yesterday
      this.tomorrow = this.article.tomorrow
      this.lastSessionData = this.article.lastSessionData
      this.nextSessionData = this.article.nextSessionData
    }
    // console.log('f: ', this.form)
    this.localStaraForm = { ...this.form }
    this.loadMeasurementUnits()
  },
  /* watch: {
    articleName (name, oldName) {
      if (name !== oldName) {
        this.disabled = false
      }
    },
    spremenjenoIme (sprememba) {
      const razlog = 'spremenjenoIme'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoInformacije (sprememba) {
      const razlog = 'spremenjenoInfo'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoCena (sprememba) {
      const razlog = 'spremenjenoCena'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoGroup (sprememba) {
      const razlog = 'spremenjenoGroup'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoCategory (sprememba) {
      const razlog = 'spremenjenoCategory'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoEnotaNakupa (sprememba) {
      const razlog = 'enotaNakupa'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoEnotaProdaje (sprememba) {
      const razlog = 'enotaProdaje'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoVisible (sprememba) {
      const razlog = 'visible'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoAskPrice (sprememba) {
      const razlog = 'askPrice'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoAskQnt (sprememba) {
      const razlog = 'askquantity'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoNameChange (sprememba) {
      const razlog = 'namechange'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    }
  } */
}
</script>
